// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__pkpX8","switch":"Toggle_switch__A9s0S","slider":"Toggle_slider__bO6Js","round":"Toggle_round__Fdl3B"};